export default __webpack_public_path__ + "static/media/review6.9c01679e.svg";